const { getElements } = window.BAO.Utils

export class ShadeFilterItem extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
    this.listeners.add(this, 'keydown', this.handleKeyDown.bind(this))
  }

  setupShadeItems (shadeGroupNameHandle) {
    // Get all colour shade elements
    const shades = document.querySelectorAll('[data-shade-groups]')

    // Iterate through each shade
    shades.forEach(shade => {
      // Get the data-shade-groups attribute and split it into an array
      const colors = shade.getAttribute('data-shade-groups').split(',')

      // Check if the colors array includes the shadeGroupNameHandle
      if (colors.includes(shadeGroupNameHandle)) {
        // If it matches, show it
        shade.parentElement.setAttribute('aria-hidden', 'false')

        // Count the number of 'shade' elements with aria-hidden false
        const visibleShadesCount = document.querySelectorAll('.prd-DetailVariants_Option-radio[aria-hidden="false"]').length

        // Update counter for visible shades
        document.querySelector('[data-shade-counter]').innerHTML = visibleShadesCount
      } else {
        // If it doesn't match, hide it
        shade.parentElement.setAttribute('aria-hidden', 'true')
      }
    })
  }

  handleKeyDown (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    this.click()
  }

  handleClick () {
    getElements('[data-filter-shade-group]').forEach((trigger) => {
      const isSelected = trigger === this

      trigger.toggleAttribute('selected', isSelected)
      trigger.setAttribute('aria-pressed', String(isSelected))
    })

    // Update label for visible shades
    document.querySelector('[data-shade-title]').innerHTML = this.innerHTML

    // Update the swatch visibility
    this.setupShadeItems(this.getAttribute('data-filter-shade-group'))

    document.querySelector('[data-shade-filter-item-external-el="option"][aria-hidden="false"] [data-shade-filter-item-external-el="button"]').click()
  }
}

if (!customElements.get('shade-filter-item')) {
  customElements.define('shade-filter-item', ShadeFilterItem)
}
